import React from 'react'
import { Container } from '@mui/material'
import { FlatPageFragment } from '@graphql/fragments/__generated__/FlatPage.generated'
import Loader from '@components/Loader'
import { useTranslation } from 'react-i18next'

interface Props {
  page: FlatPageFragment | null
  isLoading: boolean
}

const Page: React.FC<Props> = ({ page, isLoading }) => {
  const { t } = useTranslation()
  return (
    <div>
      <Container maxWidth='lg'>
        <div className='my-40'>
          {!page && !isLoading && (
            <h3 className='text-center font-bold uppercase'>{t('wholesale.termsOfService', 'Terms of service')}</h3>
          )}
          {!page && isLoading && (
            <Loader className='spinner global' type='ThreeDots' color='#333' height={100} width={100} visible />
          )}
          {page && <div dangerouslySetInnerHTML={{ __html: page.content }} />}
        </div>
      </Container>
    </div>
  )
}

export default Page
